var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-level-banner"},[_c('div',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.$t('choose_your_hsk_level')))]),_c('div',{staticClass:"banner-desc"},[_vm._v(_vm._s(_vm.$t('choose_your_hsk_level_desc')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }